<template>
  <AppLayout :title="`Caixa #${id}`" back-to="cashiers">
    <div v-if="!resumo" class="text-muted">Carregando...</div>

    <div v-else>
      <div class="card mb-3">
        <div class="card-body">
          <div class="row">
            <div class="col-md-3">
              <strong>Operador:</strong><br>
              {{ resumo.cashier.operator?.name ?? '-' }}
            </div>
            <div class="col-md-3">
              <strong>Aberto em:</strong><br>
              {{ formaterService.dateTime(resumo.cashier.created_at) }}
            </div>
            <div class="col-md-3">
              <strong>Fechado em:</strong><br>
              {{ formaterService.dateTime(resumo.cashier.updated_at) }}
            </div>
            <div class="col-md-3">
              <strong>Total vendido:</strong><br>
              {{ formaterService.currency(resumo.cashier.sell_total) ?? 'R$ 0,00' }}
            </div>
          </div>
          <hr>
          <div class="row">
            <div class="col-md-3">
              <strong>Valor de abertura:</strong><br>
              {{ formaterService.currency(resumo.cashier.open) ?? 'R$ 0,00' }}
            </div>
            <div class="col-md-3">
              <strong>Valor de fechamento:</strong><br>
              {{ formaterService.currency(resumo.cashier.close) ?? 'R$ 0,00' }}
            </div>
            <div class="col-md-3">
              <strong>Lucro (saldo):</strong><br>
              {{ formaterService.currency(resumo.cashier.balance) ?? 'R$ 0,00' }}
            </div>
          </div>
          <hr>
          <div class="row">
            <div class="col-md-3">
              <strong>Dinheiro:</strong><br>
              {{ formaterService.currency(resumo.cashier.cash) ?? 'R$ 0,00' }}
            </div>
            <div class="col-md-3">
              <strong>Pix:</strong><br>
              {{ formaterService.currency(resumo.cashier.pix) ?? 'R$ 0,00' }}
            </div>
            <div class="col-md-3">
              <strong>Cartão:</strong><br>
              {{ formaterService.currency(resumo.cashier.card) ?? 'R$ 0,00' }}
            </div>
            <div class="col-md-3">
              <strong>Na conta (fiado):</strong><br>
              {{ formaterService.currency(resumo.cashier.onaccont) ?? 'R$ 0,00' }}
            </div>
          </div>
        </div>
      </div>

      <h2 class="section-title">Vendas do caixa</h2>
      <div class="table-card">
        <table class="table">
          <thead>
            <tr>
              <th>Cliente</th>
              <th>Data</th>
              <th>Pagamento</th>
              <th>Valor</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="venda in resumo.sales" :key="venda.id">
              <td>{{ venda.customer?.name ?? 'Avulso' }}</td>
              <td>{{ formaterService.dateTime(venda.date) }}</td>
              <td>{{ venda.payment_method?.name ?? formaterService.payment(venda.payment) }}</td>
              <td>{{ formaterService.currency(venda.value) }}</td>
              <td style="width:40px">
                <router-link :to="{ name: 'sale-detail', params: { id: venda.id } }" class="btn btn-info btn-sm">
                  <i class="bi bi-info-square-fill"></i>
                </router-link>
              </td>
            </tr>
            <tr v-if="!resumo.sales.length">
              <td colspan="5" class="text-center text-muted">Nenhuma venda registrada neste caixa.</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </AppLayout>
</template>
<script>
import AppLayout from "@/components/AppLayout.vue";
import { onMounted, ref } from 'vue';
import { useRoute } from 'vue-router';
import { caixas } from "@/models/caixas";
import formaterService from "@/services/formaterService";

export default {
  name: 'CashierDetailView',
  components: {
    AppLayout
  },
  setup() {
    const route = useRoute();
    const id = route.params.id;
    const resumo = ref(null);
    const Caixas = caixas();

    onMounted(async () => {
      resumo.value = await Caixas.show(id);
    });

    return { id, resumo, formaterService }
  },
}
</script>
<style scoped>
.section-title {
  font-size: 1.05rem;
  font-weight: 600;
  color: var(--text-strong);
  margin-bottom: 0.75rem;
}
</style>
